import { IChildrenCacheProps } from "./interfaces";
import { useChildrenCache } from "./useChildrenCache";

/**
 * Supports use of Google Translate with React components.
 */
export function ChildrenCache(props: IChildrenCacheProps) {
  const { childrenCacheEntries } = useChildrenCache(props);

  /**
   * Render all known children from cache as a <span>, but only the current `children` is visible.
   * This allows Google Translate to translate all variants of the button text and prevents us from reverting the translation.
   */
  return (
    <>
      {childrenCacheEntries.map(([key, value]) => (
        <span key={key} hidden={props.children !== value}>{value}</span>
      ))}
    </>
  );
}
